<template>
  <modal width="90%" v-if="dialog" @close="closeDialog">
    <div slot="header">
      <h3>Información y documentación requerida</h3>
    </div>

    <slot name="content"></slot>
  </modal>
</template>

<script>
import FilesTab from "./FilesTab";

export default {
  name: "FilesModal",
  components: { FilesTab },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  padding: 0 12px;
}
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/FilesModal.vue